import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://cqapi.sensiblebrains.com/api';

const API = axios.create({ baseURL: API_BASE });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const login = (data) => API.post('/admin/login', data);

// Public
export const getJobs = () => API.get('/jobs');
export const getFeaturedJobs = () => API.get('/jobs?featured=1');
export const getJob = (id) => API.get(`/jobs/${id}`);
export const getCategories = () => API.get('/categories');
export const getEmployers = () => API.get('/employers');
export const submitApplication = (data) => API.post('/applications', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const postResume = (data) => API.post('/resumes', data, { headers: { 'Content-Type': 'multipart/form-data' } });

// Public: Locations
export const getLocations = () => API.get('/locations');
export const searchLocations = (q) => API.get(`/locations?q=${encodeURIComponent(q)}`);

// Admin Locations
export const getAdminLocations = () => API.get('/admin/locations');
export const createLocation = (data) => API.post('/admin/locations', data);
export const updateLocation = (id, data) => API.put(`/admin/locations/${id}`, data);
export const deleteLocation = (id) => API.delete(`/admin/locations/${id}`);

// Admin Jobs
export const getAdminJobs = () => API.get('/admin/jobs');
export const createJob = (data) => API.post('/admin/jobs', data);
export const updateJob = (id, data) => API.put(`/admin/jobs/${id}`, data);
export const deleteJob = (id) => API.delete(`/admin/jobs/${id}`);

// Admin Categories
export const getAdminCategories = () => API.get('/admin/categories');
export const createCategory = (data) => API.post('/admin/categories', data);
export const updateCategory = (id, data) => API.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => API.delete(`/admin/categories/${id}`);

// Admin Employers
export const getAdminEmployers = () => API.get('/admin/employers');
export const createEmployer = (data) => API.post('/admin/employers', data);
export const updateEmployer = (id, data) => API.put(`/admin/employers/${id}`, data);
export const deleteEmployer = (id) => API.delete(`/admin/employers/${id}`);

// Public: Employer Requirements & Industry Enquiries
export const submitEmployerRequirement = (data) => API.post('/employer-requirements', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const submitIndustryEnquiry = (data) => API.post('/industry-enquiries', data);

// Admin: Employer Requirements & Industry Enquiries
export const getAdminEmployerRequirements = () => API.get('/admin/employer-requirements');
export const getAdminIndustryEnquiries = () => API.get('/admin/industry-enquiries');

// Admin Other
export const getAdminApplications = () => API.get('/admin/applications');
export const getAdminApplication = (id) => API.get(`/admin/applications/${id}`);
export const getAdminResumes = () => API.get('/admin/resumes');
export const getAdminStats = () => API.get('/admin/stats');
export const downloadResume = (filename) => `${API_BASE}/admin/download/${filename}`;
